import WsService from "services/WsService";
import S3DocumentMetaDataWithUrl from "../domain/Registration/S3DocumentMetaDataWithUrl";

const ENDPOINT_BASE = "/s3-documents";

export default class S3DocumentUploadService {

    static retrieveS3DocumentWithUrl(id) {

        let endpoint = ENDPOINT_BASE + "/" + id;
        return WsService.get(endpoint, {}, 200).then(
            response => {
                return new S3DocumentMetaDataWithUrl(response);
            },
            response => {
                return response;
            });
    }

    static getPresignedUrl(uploadRequest) {

        let endpoint = ENDPOINT_BASE + "/save-and-generate-upload-url";
        return WsService.post(endpoint, uploadRequest, 200).then(
            response => {
                // success
                return new S3DocumentMetaDataWithUrl(response);
            },
            response => {
                // fail
                return response;
            });
    }

    static insertS3MetaData(metaData) {

        let endpoint = ENDPOINT_BASE;
        let jsonObj = S3DocumentMetaDataWithUrl.toJson(metaData);
        return WsService.post(endpoint, jsonObj, 201).then(
            response => {
                // success
                return new S3DocumentMetaDataWithUrl(response);
            },
            response => {
                // fail
                return response;
            });
    }

}


